module.exports = "/_next/static/images/Nathan-5ce49330f78295da7671a3de021d6226.jpg";